import { makeSimpleStore } from "@/shared/utils/simpleStoreUtils";
import { UnwrapNestedRefs } from "@vue/reactivity";
import {
  CompanyRoleOfClient,
  CompanyType,
  PersonTitleEnum,
} from "@/../__generated__/globalTypes";

export type RegistrationData = {
  email: string;
  mobile: string;
  password: string;
  repeatPassword?: string;
  pageNumber: number;
  status?: string;
  terms: boolean;
  isNumberInWhitelist?: boolean;
  // Personal
  title?: PersonTitleEnum | null;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  countryOfResidence?: string | null;
  countryOfNationality?: string | null;
  // Corporate
  companyName?: string;
  legalForm?: CompanyType | null;
  countryOfIncorporation?: string;
  companyRole: CompanyRoleOfClient | null;
  companyRegistrationNumber: string | null;

  emailCode: string;
  mobileCode: string;
};

export type RegistrationSimpleStore = UnwrapNestedRefs<
  RegistrationData & { resetStore: () => void }
>;

export const registrationSimpleStore: RegistrationSimpleStore =
  makeSimpleStore<RegistrationData>({
    email: "",
    mobile: "",
    password: "",
    repeatPassword: "",
    pageNumber: 0,
    status: "",
    terms: false,
    isNumberInWhitelist: false,
    // Personal
    title: null,
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    countryOfResidence: null,
    countryOfNationality: null,
    // Corporate
    companyName: "",
    legalForm: null,
    countryOfIncorporation: "",
    companyRole: null,
    companyRegistrationNumber: null,
    emailCode: "",
    mobileCode: "",
  });
